module.exports = __webpack_public_path__ + "img/bildschirmfoto01.48461db1.png";